import { IKeywordBoost } from 'api/types/_keyword';
import { Option } from 'api/types/_public';
import { CONFIG_OPTION_TOAST_ERROR, CONFIG_OPTION_TOAST_NORMAL } from 'common/toast';
import BreadCrumb from 'components/Common/BreadCrumb';
import DropdownOption from 'components/Common/DropdownOption';
import InputsRange from 'components/Common/InputsRange';
import LabelWrapper from 'components/Common/LabelWrapper';
import ModalConfirm from 'components/Common/ModalConfirm';
import { useRole } from 'components/Hooks/UserHooks';
import RangeDatePicker from 'components/pickers/RangeDatePicker';
import en from 'date-fns/locale/en-US';
import ko from 'date-fns/locale/ko';
import { STATUS_KEYWORD_BOOST_OPTIONS, STATUS_USER_OPTIONS } from 'helpers/constans';
import { formatNumberWithCommas } from 'helpers/format';
import { isHavePermissionRole, ROLES_FOR_APP } from 'helpers/role';
import moment from 'moment';
import React, { useCallback, useEffect, useMemo, useState } from "react";
import CountUp from 'react-countup';
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Card, CardBody, CardHeader, Col, Container, Input, Row, Spinner } from "reactstrap";
import { createSelector } from "reselect";
import { NumberParam, StringParam, useQueryParams, withDefault } from 'use-query-params';
import TableContainer from "../../components/Common/TableContainer";
import { deleteKeywordBoostV2Multi, downloadExcelKeywordRealTime, getKeywordBoostV2Statistics, getKeywordRealTimes as onGetKeywordRealTimes, putKeywordBoostV2, putStatusKeywordV2Multi, setKeywordRealTimeGenerateArticleMulti, setKeywordTaskFromKeywordRealTimeMulti } from "../../store/thunks";
export interface Tag {
  id: string;
  text: string;
}

const TYPE_SELECT_DEFAULT: string = 'pv';

registerLocale('en', en);
registerLocale('ko', ko);


const KeywordRealTime = () => {
  const { t, i18n } = useTranslation();
  const { userPermissions } = useRole();
  const navigate = useNavigate();

  const STATUS_USER_OPTIONS_LANG: any = STATUS_USER_OPTIONS?.map((item: any) => ({ value: item?.value, label: t(item?.label) }));

  const STATUS_KEYWORD_BOOST_OPTIONS_LANG = STATUS_KEYWORD_BOOST_OPTIONS?.map((item: any) => ({
    value: item?.value,
    label: t(item?.label),
  }));

  const [query, setQuery]: any = useQueryParams({
    time_request: withDefault(NumberParam, 0),
    page: withDefault(NumberParam, 1),
    limit: withDefault(NumberParam, 100),
    sort_by: withDefault(StringParam, TYPE_SELECT_DEFAULT),
    order_by: withDefault(StringParam, 'DESC'),
    date: withDefault(StringParam, moment().format("Y-MM-DD")),
    keyword: withDefault(StringParam, ''),
    // category_id: withDefault(StringParam, ''),
    pv_start: withDefault(StringParam, ''),
    pv_end: withDefault(StringParam, ''),
    uv_start: withDefault(StringParam, ''),
    uv_end: withDefault(StringParam, ''),
    pa_media_ranking_start: withDefault(StringParam, ''),
    pa_media_ranking_end: withDefault(StringParam, ''),

  });

  const [isLoadingExportFile, setIsLoadingExportFile] = useState<boolean>(false);

  const [totalKeywordBoostActivates, setTotalKeywordBoostActivates] = useState<number>(0);

  const [idLoading, setIdLoading] = useState<string | number | null>(null);

  const [isOpenConfirm, setIsConfirm] = useState<boolean>(false);
  const [isConfirmLoading, setIsConfirmLoading] = useState<boolean>(false);
  const [initialValuesDefault, setInitialValuesDefault] = useState<IKeywordBoost | null>(null);

  const [keywordSearch, setKeywordSearch] = useState<string>(query?.keyword || "");

  const [statusSearch, setStatusSearch] = useState<Option | null>(STATUS_USER_OPTIONS_LANG?.find((item: any) => String(item?.value) === String(query?.status)) || null);

  const [startUVSearch, setStartUVSearch] = useState<string>(query?.uv_start || "");
  const [endUVSearch, setEndUVSearch] = useState<string>(query?.uv_end || "");

  const [startPVSearch, setStartPVSearch] = useState<string>(query?.pv_start || "");
  const [endPVSearch, setEndPVSearch] = useState<string>(query?.pv_end || "");

  const [startMonthlyVolumeSearch, setStartMonthlyVolumeSearch] = useState<string>(query?.start_monthly_search_volume || "");
  const [endMonthlyVolumeSearch, setEndMonthlyVolumeSearch] = useState<string>(query?.end_monthly_search_volume || "");

  const [startAffiliateSearch, setStartAffiliateSearch] = useState<string>(query?.pa_media_ranking_start || "");
  const [endAffiliateSearch, setEndAffiliateSearch] = useState<string>(query?.pa_media_ranking_end || "");

  const [dateSearch, setDateSearch] = useState<any>(query?.date ? moment(query?.date, 'Y-MM-DD').toDate() : null);

  const [keywordEdit, setKeywordEdit] = useState<IKeywordBoost & { isCopy?: boolean } | null>(null);

  const [isOpen, setIsOpen] = useState<boolean>(false);

  const [isOpenConfirmChangeStatusMulti, setIsOpenConfirmChangeStatusMulti] = useState<"ACTIVATE" | "DEACTIVATE" | false>(false);

  const [isOpenSetTaskKeyword, setIsOpenSetTaskKeyword] = useState<boolean>(false);

  const [isOpenSetGenerateArticle, setIsOpenSetGenerateArticle] = useState<boolean>(false);

  const [optionsSelected, setOptionsSelected] = useState<any>([]);

  const dispatch: any = useDispatch();

  const selectLayoutState = (state: any) => state.Keyword;

  const KeywordProperties = createSelector(
    selectLayoutState,
    (state) => ({
      keywordRealTimes: state.keywordRealTimes,
      isKeywordRealTimeSuccess: state.isKeywordRealTimeSuccess,
      isKeywordRealTimeLoading: state.isKeywordRealTimeLoading,
      error: state.error,
    })
  );

  // Inside your component
  const { keywordRealTimes, error, isKeywordRealTimeLoading } = useSelector(KeywordProperties);

  const onGetKeywordBoostV2Statistics = (params: any) => {
    getKeywordBoostV2Statistics(params).then((res: any) => {
      setTotalKeywordBoostActivates((_prev) => res?.data?.active_count || 0)
    }).catch((error) => { });
  };

  useEffect(() => {
    dispatch(onGetKeywordRealTimes(query));
  }, [dispatch, JSON.stringify(query)]);

  const searchData = () => {
    if (isKeywordRealTimeLoading) {
      return;
    }
    setOptionsSelected((prev: any) => []);
    const queryNew = {
      ...query,
      keyword: keywordSearch || '',
      date: dateSearch ? moment(new Date(dateSearch)).format("Y-MM-DD") : '',
      uv_start: startUVSearch || '',
      uv_end: endUVSearch || '',
      pv_start: startPVSearch || '',
      pv_end: endPVSearch || '',
      pa_media_ranking_start: startAffiliateSearch || '',
      pa_media_ranking_end: endAffiliateSearch || '',
      start_monthly_search_volume: startMonthlyVolumeSearch || '',
      end_monthly_search_volume: endMonthlyVolumeSearch || '',
      page: 1,
      time_request: + new Date()
    };
    setQuery(queryNew);
  };

  const resetData = () => {
    const queryNew = {
      ...query,
      keyword: '',
      uv_start: '',
      uv_end: '',
      pv_start: '',
      pv_end: '',
      pa_media_ranking_start: '',
      pa_media_ranking_end: '',
      start_monthly_search_volume: '',
      end_monthly_search_volume: '',
      category_id: '',
      order_by: 'DESC',
      sort_by: TYPE_SELECT_DEFAULT,
      date: `${moment().format("Y-MM-DD")}`,
      time_request: + new Date(),
      page: 1,
    };
    setQuery(queryNew, "push");
    setKeywordSearch((_prev) => "");
    setStartUVSearch(queryNew?.uv_start);
    setEndUVSearch(queryNew?.uv_end);
    setStartPVSearch(queryNew?.pv_start);
    setEndPVSearch(queryNew?.pv_end);
    setStartAffiliateSearch(queryNew?.pa_media_ranking_start);
    setEndAffiliateSearch(queryNew?.pa_media_ranking_end);
    setDateSearch(moment(queryNew?.date || "", 'Y-MM-DD').toDate());
  };
  // 

  // Begin::Update keyword
  const handleUpdateBoostKeyword = async (dataSubmit: { id: string | number, status: number, keyword_sub: string } | undefined = undefined) => {
    try {
      if (!keywordEdit?.id && !dataSubmit) {
        return;
      }
      setIdLoading((_prev) => (dataSubmit?.id || keywordEdit?.id) as string);
      const data = !!dataSubmit ? ({
        status: dataSubmit?.status,
        keyword_sub: dataSubmit?.keyword_sub || '',
      }) : ({
        status: keywordEdit?.status,
        keyword_sub: keywordEdit?.keyword_sub || '',
      });
      const response: any = await putKeywordBoostV2((dataSubmit?.id || keywordEdit?.id) as string, data);
      if (response?.code === 200) {
        setIdLoading((_prev) => null);
        toast(
          `${t("The process has been completed.")}`,
          CONFIG_OPTION_TOAST_NORMAL
        );
        triggerRefresh();
      } else {
        setIdLoading((_prev) => null);
        toast(`${response?.message || response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIdLoading((_prev) => null);
      toast(`${error?.message || ""}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }

  };

  const onCloseClick = () => {
    setKeywordEdit((_prev) => null);
    setIsOpen((_prev) => false);
  }

  const triggerRefresh = (is_refresh_categories: boolean = false) => {
    onCloseClick();
    onCloseConfirmChangeStatusMultiClick();
    setQuery({
      ...query,
      ...(!!is_refresh_categories ? { category_id: '' } : {}),
      time_request: + new Date(),
    });
    // onGetKeywordBoostV2Statistics(query);
    if (is_refresh_categories) {
      handleCallAllOption();
    }
  }
  //End::Update User

  // Begin::Delete
  const handleConfirmDelete = (item: IKeywordBoost | null) => {
    setInitialValuesDefault((_prev) => item);
    setIsConfirm((_prev) => true);
  };

  const handleActionDelete = async () => {
    if (!initialValuesDefault?.id && !countRowSelected) { return; };
    try {
      setIsConfirmLoading((_prev) => true);
      const ids = initialValuesDefault?.id ? [initialValuesDefault?.id] : (optionsSelected || []).flat()?.map((item: any) => item?.value);
      const response: any = await deleteKeywordBoostV2Multi({
        ids: ids
      });
      if (response?.code === 200) {
        triggerRefresh();
        setIsConfirmLoading((_prev) => false);
        setIsConfirm((_prev) => false);
        setInitialValuesDefault((_prev) => null);
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
        if (!initialValuesDefault?.id) {
          setOptionsSelected((prev: any) => []);
        }
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseConfirmClick = () => {
    setInitialValuesDefault((_prev) => null);
    setIsConfirm((_prev) => false);
  }
  // End::Delete

  // Begin::Set Task Keyword
  const handleConfirmSetTaskKeyword = () => {
    setIsOpenSetTaskKeyword((_prev) => true);
  };

  const handleActionSetTaskKeyword = async () => {
    if (!initialValuesDefault?.id && !countRowSelected) { return; };
    try {
      setIsConfirmLoading((_prev) => true);
      const ids = initialValuesDefault?.id ? [initialValuesDefault?.id] : (optionsSelected || []).flat()?.map((item: any) => item?.value);
      const response: any = await setKeywordTaskFromKeywordRealTimeMulti({
        keyword_ids: ids,
      });
      if (response?.code === 200) {
        triggerRefresh();
        setIsConfirmLoading((_prev) => false);
        setIsOpenSetTaskKeyword((_prev) => false);
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
        if (!initialValuesDefault?.id) {
          setOptionsSelected((prev: any) => []);
        }
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseConfirmSetTaskKeywordClick = () => {
    setIsOpenSetTaskKeyword((_prev) => false);
  }
  // End::Set Task Keyword


  // Begin::Set Generate Article 
  const handleConfirmSetGenerateArticle = () => {
    setIsOpenSetGenerateArticle((_prev) => true);
  };

  const handleActionSetGenerateArticle = async () => {
    if (!countRowSelected) { return; };
    try {
      setIsConfirmLoading((_prev) => true);
      const ids = (optionsSelected || []).flat()?.map((item: any) => item?.value);
      const response: any = await setKeywordRealTimeGenerateArticleMulti({
        ids: ids,
      });
      if (response?.code === 200) {
        triggerRefresh();
        setIsConfirmLoading((_prev) => false);
        setIsOpenSetGenerateArticle((_prev) => false);
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
        setOptionsSelected((prev: any) => []);
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseConfirmSetGoldenKeywordClick = () => {
    setIsOpenSetGenerateArticle((_prev) => false);
  }
  // End::Set Generate Article 

  const handleDownloadExcel = async () => {
    try {
      setIsLoadingExportFile((_prev) => true);
      const response: any = await downloadExcelKeywordRealTime({ ...query });
      if (response?.data) {
        setIsLoadingExportFile((_prev) => false);
        const link = document.createElement('a');
        link.href = response?.data?.url;
        link.download = 'task_keywords';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        setIsLoadingExportFile((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsLoadingExportFile((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  }

  // Begin:: handle select table 
  const handleCheck = (valueCheck: Option, valueIndex: number | string, e: any = null) => {
    // if (!!isFirstLoadingPageRef.current) {
    //   return;
    // }
    const index = String(valueIndex);
    if (valueCheck?.value === 'ALL') {
      setOptionsSelected((prev: any) => {
        const prevClone = structuredClone(prev);
        if (e.target.checked) {
          if (prevClone[index] === undefined) {
            prevClone[index] = [];
          }
          prevClone[index] = (keywordRealTimes?.list || [])?.map((item: any) => ({ value: item?.id, label: item?.id }));
          return prevClone;
        } else {
          prevClone[index] = [];
          return prevClone;
        }
      });
      return;
    }
    if (!e.target.checked) {
      setOptionsSelected((prev: any) => {
        const prevClone = structuredClone(prev);
        if (prevClone[index] === undefined) {
          prevClone[index] = [];
        }
        prevClone[index] = (prevClone[index] || [])?.filter((item: any) => (item?.value !== valueCheck?.value));
        return prevClone;
      });
    } else {
      setOptionsSelected((prev: any) => {
        const prevClone = structuredClone(prev);
        if (prevClone[index] === undefined) {
          prevClone[index] = [];
        }
        prevClone[index] = ([...prevClone[index], valueCheck]);
        return prevClone;
      });
    }
  };

  const isChecked = (valueCheck: Option) => {
    const index = String(query.page);
    return !!(optionsSelected[index]?.find((x: any) => x.value === valueCheck?.value)?.value);
  };

  const isCheckedAll = (valueIndex: string) => {
    const valueIndexString = String(valueIndex);
    return (optionsSelected[valueIndexString]?.length > 0 && optionsSelected[valueIndexString]?.length === keywordRealTimes?.list?.length);
  };

  const countRowSelected = useMemo(() => {
    return Object.entries(optionsSelected)?.reduce((total: number, [key, value]: any) => {
      return Number(total + (value || [])?.length);
    }, 0)
  }, [optionsSelected]);

  // End:: handle select table 

  // Column
  const columns = useMemo(
    () => [
      // {
      //   Header: t('Ranking'),
      //   accessor: "rank",
      //   filterable: true,
      //   sortable: false,
      //   thClass: 'align-middle text-start',
      //   thWidth: 90,
      //   Cell: (cell: any) => {
      //     const item = cell?.row?.original;
      //     return (
      //       <>
      //         <div className="text-start" style={{ minWidth: '60px' }}>{((query?.page - 1) * (query?.limit)) + (cell?.cell?.row?.index + 1)}</div>
      //       </>
      //     )
      //   },
      // },
      {
        Header: t('Key'),
        accessor: "",
        filterable: true,
        sortable: false,
        thClass: 'text-start align-middle',
        thWidth: 50,
        thComponent: () => (<>
          <div className="form-check">
            <input className="form-check-input" type="checkbox" checked={isCheckedAll(query?.page)} onChange={(e) => handleCheck(({ value: 'ALL', label: '' }), query?.page, e)} value="" id={`cell-check-all`} />
            <label className="form-check-label" htmlFor={`cell-check-all`}></label>
          </div>
        </>
        ),
        Cell: (cell: any) => {
          const item: any = cell?.row?.original;
          const __id = item?.id;
          return (
            <>
              <div className={`form-check`}>
                <input className="form-check-input" type="checkbox" name="table" checked={isChecked({ value: __id, label: __id })} value={__id ?? ''} onChange={(e) => handleCheck(({ value: __id, label: __id }), query?.page, e)} id={`cell-check-${__id ?? ''}`} />
                <label className="form-check-label" htmlFor={`cell-check-${__id ?? ''}`}></label>
              </div>
            </>
          )
        },
      },
      {
        Header: t('ID'),
        accessor: "id",
        filterable: true,
        sortable: false,
        thWidth: 80,
        thClass: 'text-start align-middle',
        Cell: (cell: any) => (
          <>
            <span style={{ minWidth: '50px' }}>{cell?.value}</span>
          </>
        ),
      },
      {
        Header: t('Keyword'),
        accessor: "keyword",
        filterable: true,
        sortable: true,
        thWidth: 180,
        thClass: 'text-start align-middle',
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div style={{ minWidth: '100px' }}>
              <Link className='text-normal nav-link  flex-grow-1 hover-underline' to={`https://search.naver.com/search.naver?ssc=tab.news.all&where=news&sm=tab_jum&query=${cell?.value || ''}`} target="_blank" style={{ minWidth: '100px' }}>
                {cell?.value || '-'}
              </Link>
            </div>
          </>)
        },
      },
      {
        Header: t('PV'),
        accessor: "pv",
        filterable: true,
        sortable: true,
        thClass: 'text-end align-middle',
        thWidth: 150,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="pe-3 text-end" style={{ minWidth: '130px' }}>{formatNumberWithCommas(cell?.value)}</div>
          </>)
        },
      },
      {
        Header: t('UV'),
        accessor: "uv",
        filterable: true,
        sortable: true,
        thClass: 'text-end align-middle',
        thWidth: 150,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="pe-3 text-end" style={{ minWidth: '130px' }}>{formatNumberWithCommas(cell?.value)}</div>
          </>)
        },
      },
      {
        Header: '',
        accessor: "__",
        filterable: true,
        sortable: false,
        thClass: 'text-end align-middle',
        thWidth: 40,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="text-end"></div>
          </>)
        },
      },
      {
        Header: t('PA Media Ranking'),
        accessor: "pa_media_ranking",
        filterable: true,
        sortable: true,
        thClass: 'align-middle text-end',
        description: t('The ranking of Press AI-affiliated media in Naver News search results. (Based on today’s data.)'),
        thWidth: i18n?.language === 'en' ? 180 : 150,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<div style={{ minWidth: i18n?.language === 'en' ? '130px' : '100px' }} className="text-end pe-info">
            {cell?.value || '-'}
          </div>)
        },
      },
      {
        Header: t('PA Media'),
        accessor: "pa_media_name",
        filterable: true,
        sortable: false,
        thClass: 'align-middle text-end',
        thWidth: i18n?.language === 'en' ? 150 : 120,
        description: t("Press AI-affiliated media."),
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<div style={{ minWidth: i18n?.language === 'en' ? '130px' : '100px' }} className="text-end pe-3">
            {cell?.value || '-'}
          </div>)
        },
      },
      {
        Header: t('Date'),
        accessor: "date",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: 'text-end align-middle',
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || '').split(' ');
          return (
            <div className="text-end" style={{ minWidth: '100px' }}>
              <span>{arrDate?.[0] || ''}</span>
            </div>
          )
        },
      },
      {
        Header: '',
        accessor: "_",
        filterable: true,
        sortable: false,
        thClass: 'text-end align-middle',
        thWidth: 40,
        Cell: (cell: any) => {
          const item = cell?.row?.original;
          return (<>
            <div className="text-end"></div>
          </>)
        },
      },
      {
        Header: t('Created At'),
        accessor: "created_at",
        filterable: true,
        sortable: true,
        thWidth: 130,
        thClass: 'align-middle text-end',
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || '').split(' ');
          return (
            <div className="text-end pe-3" style={{ minWidth: '120px' }}>
              <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
            </div>
          )
        },
      },
      {
        Header: t('Updated at'),
        accessor: "updated_at",
        filterable: true,
        sortable: false,
        thWidth: 150,
        thClass: 'text-end align-middle',
        Cell: (cell: any) => {
          const arrDate = String(cell?.value || '').split(' ');
          return (
            <div className="text-end" style={{ minWidth: '100px' }}>
              <span><span>{arrDate?.[0] || ''}</span> <br /> <span className="text-secondary">{arrDate?.[1] || ''}</span> </span>
            </div>
          )
        },
      },
    ],
    [i18n?.language, query, userPermissions, idLoading, JSON.stringify(optionsSelected), keywordRealTimes?.pagination?.total]
  );

  // Begin::Update status
  const handleConfirmChangeStatusMulti = (type_status: "ACTIVATE" | "DEACTIVATE") => {
    setIsOpenConfirmChangeStatusMulti((_prev) => type_status);
  };

  const handleActionChangeStatus = async () => {
    try {
      setIsConfirmLoading((_prev) => true);
      const kw_s = (optionsSelected || []).flat()?.map((item: any) => item?.value);
      const type_status: any = isOpenConfirmChangeStatusMulti || 'ACTIVE';
      const response: any = await putStatusKeywordV2Multi(type_status, {
        ids: kw_s,
      });
      if (response?.code === 200) {
        toast(`${t('The process has been completed.')}`, CONFIG_OPTION_TOAST_NORMAL);
        triggerRefresh();
        setIsConfirmLoading((_prev) => false);
        setIsOpenConfirmChangeStatusMulti((_prev) => false);
        setOptionsSelected((prev: any) => []);
      } else {
        setIsConfirmLoading((_prev) => false);
        toast(`${response}`, CONFIG_OPTION_TOAST_ERROR);
      }
    } catch (error: any) {
      setIsOpenConfirmChangeStatusMulti((_prev) => false);
      setIsConfirmLoading((_prev) => false);
      toast(`${error?.message || ''}`, CONFIG_OPTION_TOAST_ERROR);
      return error;
    }
  };

  const onCloseConfirmChangeStatusMultiClick = () => {
    setIsOpenConfirmChangeStatusMulti((_prev) => false);
  }
  // End::Update status

  const handleChangePage = useCallback((page: any) => {
    setQuery({ page: page + 1 })
  }, []);

  const handleChangeSorting = useCallback((sortBy: any) => {
    setQuery((_prev: any) => {
      return ({ ..._prev, ...sortBy });
    });
  }, []);

  const handleChangeDatePicker = (date: any) => {
    setDateSearch((_prev: any) => date);
  };

  const changeLimitPerPage = (limit: number) => {
    if (String(limit) === String(query?.limit)) {
      return;
    }
    const queryNew = {
      ...query,
      limit: limit,
      time_request: + new Date(),
      page: 1,
    };
    setQuery(queryNew, "push");
    setOptionsSelected((prev: any) => []);
  };

  const handleCallAllOption = async () => {
    try {

    } catch (error: any) {
      return error;
    }
  };

  useEffect(() => {
    handleCallAllOption();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    document.title = `${t('Keyword')} - ${t('Real-Time Keyword')} | PRESS Ai`;
    document.body.classList.remove('vertical-sidebar-enable');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n?.language]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title={t('Real-Time Keyword')} pageTitle={t('Keyword')} />
          <Row>
            {isHavePermissionRole(ROLES_FOR_APP.KEYWORD_REAL_TIME_LIST, userPermissions) && (
              <Col lg={12}>
                <Card id="customerList" style={{ boxShadow: '0px 3px 4px 0px rgba(0, 0, 0, 0.03)' }}>
                  <CardHeader className="border-0">
                    <Row className="g-4 align-items-center">
                      <div className="col-sm-4 col-md-6 ">
                        <div>
                          <h5 className="card-title mb-0">
                            <span>
                              <span className="me-2">{t('Total')}:</span>
                              {(isKeywordRealTimeLoading) ? <Spinner size="sm" className="text-primary"></Spinner> : (<CountUp
                                start={0}
                                end={keywordRealTimes?.pagination?.total || 0}
                                duration={1}
                                className="text-primary"
                              />)}
                            </span>
                            {/* <span className="mx-2 text-muted">|</span>
                            <span>
                              <span className="me-2">{t('Activates')}:</span>
                              <span className="text-primary">{formatNumberWithCommas(totalKeywordBoostActivates || 0)}</span>
                            </span> */}
                          </h5>
                        </div>
                      </div>
                      <div className="col-sm-8 col-md-6 text-end">
                        <div className={`d-flex gap-3 flex-wrap justify-content-end`}>
                          {isHavePermissionRole(ROLES_FOR_APP.KEYWORD_REAL_TIME_LIST, userPermissions) && (<button
                            type="button"
                            className="btn btn-success add-btn rounded-pill mb-2 mb-sm-0"
                            onClick={handleDownloadExcel}
                            disabled={isLoadingExportFile}
                          >
                            {isLoadingExportFile ? <Spinner size="sm" ></Spinner> : <i className="ri-download-line align-bottom"></i>}
                            <span className="ms-1">{t('Button Download Excel')}</span>
                          </button>)}
                        </div>
                      </div>
                    </Row>
                  </CardHeader>
                  <div className=" border border-dashed border-end-0 border-start-0 card-body mt-0 pb-4">
                    <Row className="g-4 align-items-center mt-0">

                      <Col sm={12} md={6} lg={6} xl={4} xxl={4} className='mt-3 mt-xxl-2' >
                        <InputsRange
                          nameFrom="from"
                          nameTo="to"
                          valueFrom={startPVSearch}
                          valueTo={endPVSearch}
                          placeholderFrom={`${t('PV (Start)')}...`}
                          placeholderTo={`${t('PV (End)')}...`}
                          labelFrom={`${t('PV (Start)')}`}
                          labelTo={`${t('PV (End)')}`}
                          isTypeNumber={true}
                          onChangeFrom={(val) => setStartPVSearch(val)}
                          onChangeTo={(val) => setEndPVSearch(val)}
                          onKeyDownFrom={(e) => {
                            if (e.key === "Enter") {
                              searchData();
                            }
                          }}
                          onKeyDownTo={(e) => {
                            if (e.key === "Enter") {
                              searchData();
                            }
                          }}
                        />
                      </Col>

                      <Col sm={12} md={6} lg={6} xl={4} xxl={4} className='mt-3 mt-xxl-2' >
                        <InputsRange
                          nameFrom="from"
                          nameTo="to"
                          valueFrom={startUVSearch}
                          valueTo={endUVSearch}
                          placeholderFrom={`${t('UV (Start)')}...`}
                          placeholderTo={`${t('UV (End)')}...`}
                          labelFrom={`${t('UV (Start)')}`}
                          labelTo={`${t('UV (End)')}`}
                          isTypeNumber={true}
                          onChangeFrom={(val) => setStartUVSearch(val)}
                          onChangeTo={(val) => setEndUVSearch(val)}
                          onKeyDownFrom={(e) => {
                            if (e.key === "Enter") {
                              searchData();
                            }
                          }}
                          onKeyDownTo={(e) => {
                            if (e.key === "Enter") {
                              searchData();
                            }
                          }}
                        />
                      </Col>

                      <Col sm={6} md={6} lg={6} xl={4} xxl={4} className='order-2 order-xl-3 order-xxl-0 date-picker-wrapper-custom mt-3 mt-xxl-2'>
                        <LabelWrapper label={t('Date')} isShow={!!dateSearch}>
                          <RangeDatePicker
                            maxDate={moment().toDate()}
                            dateSearch={dateSearch}
                            handleChangeDatePicker={handleChangeDatePicker}
                          />
                        </LabelWrapper>
                      </Col>

                      <Col sm={12} md={6} lg={6} xl={4} xxl={4} className='mt-3 order-1 order-xxl-0' >
                        <InputsRange
                          nameFrom="from"
                          nameTo="to"
                          valueFrom={startAffiliateSearch}
                          valueTo={endAffiliateSearch}
                          placeholderFrom={`${t('PA Media Ranking (Start)')}...`}
                          placeholderTo={`${t('PA Media Ranking (End)')}...`}
                          labelFrom={`${t('PA Media Ranking (Start)')}`}
                          labelTo={`${t('PA Media Ranking (End)')}`}
                          isTypeNumber={true}
                          onChangeFrom={(val) => setStartAffiliateSearch(val)}
                          onChangeTo={(val) => setEndAffiliateSearch(val)}
                          onKeyDownFrom={(e) => {
                            if (e.key === "Enter") {
                              searchData();
                            }
                          }}
                          onKeyDownTo={(e) => {
                            if (e.key === "Enter") {
                              searchData();
                            }
                          }}
                        />
                      </Col>

                      <Col sm={6} md={6} lg={6} xl={4} xxl={4} className='order-3 order-xl-2 order-xxl-0 mt-3'>
                        <LabelWrapper label={t('Keyword')} isShow={!!keywordSearch}>
                          <Input
                            type="text"
                            className="form-control search"
                            placeholder={`${t('Keyword')}...`}
                            value={keywordSearch}
                            onChange={(e) => setKeywordSearch(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === "Enter") {
                                searchData();
                              }
                            }}
                          />
                        </LabelWrapper>
                      </Col>



                      <Col sm={12} md={6} lg={6} xl={4} xxl={4} className="order-4 order-xxl-0 hstack gap-1 justify-content-center justify-content-sm-end justify-content-xxl-end mt-3">
                        <div>
                          <button
                            type="button"
                            className="btn btn-primary me-2 "
                            onClick={searchData}
                            disabled={isKeywordRealTimeLoading}
                          >
                            <i className="ri-search-line align-bottom me-1"></i>{" "}
                            {t('Button Search')}
                          </button>
                          <button
                            type="button"
                            className="btn btn-secondary fs-14"
                            onClick={resetData}
                          >
                            <i className="ri-refresh-line align-bottom me-1"></i>{" "}
                            {t('Button Reset')}
                          </button>
                        </div>
                      </Col>
                      <Col sm={12} md={12} xl={12} className="order-5 order-xxl-0 my-0 mt-5 text-start d-flex flex-wrap gap-3 justify-content-between align-items-center">
                        <div className="d-flex flex-wrap gap-2 gap-md-3">
                          {isHavePermissionRole(ROLES_FOR_APP.KEYWORD_REAL_TIME_LIST, userPermissions) &&
                            <button
                              type="button"
                              className="btn btn-soft-info"
                              style={{ width: i18n?.language === 'en' ? '175px' : '130px' }}
                              disabled={countRowSelected <= 0}
                              onClick={(e) => { e.stopPropagation(); handleConfirmSetTaskKeyword() }}
                            >
                              {countRowSelected > 0 && (
                                <span
                                  className="position-absolute topbar-badge badge rounded-pill bg-danger"
                                  style={{ transform: "translate(0%, -70%)" }}
                                >
                                  {formatNumberWithCommas(countRowSelected)}
                                  <span className="visually-hidden">
                                    total keywords selected
                                  </span>
                                </span>
                              )}
                              {t('Button Add to Task Keyword')}
                            </button>
                          }
                          {isHavePermissionRole(ROLES_FOR_APP.KEYWORD_REAL_TIME_LIST, userPermissions) &&
                            <button
                              type="button"
                              className="btn btn-soft-success"
                              style={{ width: i18n?.language === 'en' ? '145px' : '90px' }}
                              disabled={countRowSelected <= 0}
                              onClick={(e) => { e.stopPropagation(); handleConfirmSetGenerateArticle() }}
                            >
                              {countRowSelected > 0 && (
                                <span
                                  className="position-absolute topbar-badge badge rounded-pill bg-danger"
                                  style={{ transform: "translate(0%, -70%)" }}
                                >
                                  {formatNumberWithCommas(countRowSelected)}
                                  <span className="visually-hidden">
                                    total keywords selected
                                  </span>
                                </span>
                              )}
                              {t('Button Generate Article')}
                            </button>
                          }
                        </div>
                        <div className="mt-3 mt-md-0">
                          <LabelWrapper label={t('Showcase')} isShow={true}>
                            <DropdownOption
                              name="showcase"
                              dataList={[{ label: '30', value: '30' }, { label: '50', value: '50' }, { label: '100', value: '100' }]}
                              placeholder={`${t("Showcase")}...`}
                              className={`dropdown-status-rounded z-hight-100`}
                              classNamePrefix="name-prefix"
                              style={{ width: '85px' }}
                              initialValue={{ label: `${query?.limit}`, value: `${query?.limit}` }}
                              onChangeSelect={(e: any) => {
                                changeLimitPerPage(e?.value);
                              }}
                            />
                          </LabelWrapper>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <CardBody className="pt-3">
                    <TableContainer
                      className="custom-header-css"
                      divClass="table-responsive table-card"
                      tableClass="align-middle sticky-table-keyword-real-time"
                      theadClass="table-light"
                      columns={columns}
                      data={keywordRealTimes?.list?.length ? keywordRealTimes?.list : []}
                      customPageSize={query.limit}
                      customPageIndex={query.page - 1}
                      totalRecords={keywordRealTimes?.pagination?.total}
                      customPageCount={Math.ceil(Number(keywordRealTimes?.pagination?.total) / Number(keywordRealTimes?.pagination?.limit))}
                      handleChangePage={handleChangePage}
                      manualSorting={true}
                      sorting={{ sort_by: query.sort_by, order_by: query.order_by }}
                      handleChangeSorting={handleChangeSorting}
                      isLoading={isKeywordRealTimeLoading}
                    />
                  </CardBody>
                </Card>
              </Col>
            )}
          </Row>
        </Container>

        <ModalConfirm
          header={isOpenConfirmChangeStatusMulti === 'ACTIVATE' ? t('Activate') : t('Deactivate')}
          textButtonConfirm={isOpenConfirmChangeStatusMulti === 'ACTIVATE' ? t('Activate') : t('Deactivate')}
          classButtonConfirm={'btn-soft-primary'}
          title={isOpenConfirmChangeStatusMulti === 'ACTIVATE' ? t("Are you sure you want to activate?") : t("Are you sure you want to deactivate?")}
          content={t("After confirming the update action, the data will be updated. Do you want to proceed with the update action.")}
          isOpen={!!isOpenConfirmChangeStatusMulti}
          classIconButtonConfirm=''
          isShowIcon={false}
          isLoading={isConfirmLoading}
          onClose={onCloseConfirmChangeStatusMultiClick}
          onConfirm={handleActionChangeStatus}
        />

        <ModalConfirm
          isShowIcon={false}
          classIconButtonConfirm=''
          classButtonConfirm={'btn-soft-info'}
          header={t('Button Add to Task Keyword')}
          textButtonConfirm={t('Button Add to Task Keyword')}
          title={t("Are you sure you want to set Task Keyword?")}
          content={t("After confirming the set action, the data will be set. Do you want to proceed with the set action.")}
          isOpen={isOpenSetTaskKeyword}
          isLoading={isConfirmLoading}
          onClose={onCloseConfirmSetTaskKeywordClick}
          onConfirm={handleActionSetTaskKeyword}
        />

        <ModalConfirm
          isShowIcon={false}
          classIconButtonConfirm=''
          classButtonConfirm={'btn-soft-success'}
          header={t('Button Generate Article')}
          textButtonConfirm={t('Button Generate Article')}
          title={t("Are you sure you want to generate article?")}
          content={t("After confirming the set action, the data will be set. Do you want to proceed with the set action.")}
          isOpen={isOpenSetGenerateArticle}
          isLoading={isConfirmLoading}
          onClose={onCloseConfirmSetGoldenKeywordClick}
          onConfirm={handleActionSetGenerateArticle}
        />

        <ModalConfirm
          header={t('Button Delete Boost Keyword')}
          isOpen={isOpenConfirm}
          isLoading={isConfirmLoading}
          onClose={onCloseConfirmClick}
          onConfirm={handleActionDelete}
        />

        <ToastContainer closeButton={false} newestOnTop={false} pauseOnFocusLoss autoClose={2000} limit={2} />

      </div >
    </React.Fragment >
  );
};

export default KeywordRealTime;